const uiHtml = `
    <button id="x1btn">×1</button>
    <button id="x2btn">×2</button>
    <button id="x4btn">×4</button>
    <span>replay</span>
    <button id="restartButton">⏮</button>
    <button id="playBtn"></button>
    <div id="pause-message">P A U S E</div>
`;

export default uiHtml;
